<template>
  <div>
    <wc-section-title title='Assets'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'assets-base',
  computed: {
    ...mapState({
      assets: state => state.icons.modules.assets,
      inventory: state => state.icons.modules.inventory,
      services: state => state.icons.modules.services,
      vehicles: state => state.icons.modules.vehicles,
      equipment: state => state.icons.modules.equipment,
      labour: state => state.icons.modules.labour
    }),
    menu () {
      return [
        {
          title: this.assets.title,
          icon: this.assets.icon,
          route: { name: 'AssetsDashboard' }
        },
        {
          title: this.inventory.title,
          icon: this.inventory.icon,
          route: { name: 'AllInventory' }
        },
        {
          title: this.labour.title,
          icon: this.labour.icon,
          route: { name: 'AllLabour' }
        },
        {
          title: this.services.title,
          icon: this.services.icon,
          route: { name: 'AllServices' }
        },
        {
          title: this.vehicles.title,
          icon: this.vehicles.icon,
          route: { name: 'AllVehicles' }
        },
        {
          title: this.equipment.title,
          icon: this.equipment.icon,
          route: { name: 'AllEquipment' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Assets Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
